/*
  size-required.js
  ----------------
  Size options render unselected on load (see snippets/product-block-variant-picker.liquid,
  sections/main-product-zelena.liquid, sections/hoz-product-page-v2.liquid — each marks its
  size group with `data-size-option`). This script stops any add-to-cart / buy-now action
  while that group has nothing selected and surfaces "Please select your size" instead.

  Blocking happens on the CAPTURE phase at the document, so it runs before the theme's own
  submit handler and before inline `onclick` handlers on the custom sections' buttons.
*/
(function () {
  'use strict';

  var GROUP_SELECTOR = '[data-size-option]';
  /* Chips + swatches carry data-option-value; the custom sections' buttons carry data-size. */
  var SELECTED_SELECTOR = [
    '[data-option-value].selected',
    '[data-option-value].active',
    '[data-size].selected',
    '[data-size].active'
  ].join(',');
  var ERROR_CLASS = 'size-required-error';
  var DEFAULT_MESSAGE = 'Please select your size';

  var ATC_SELECTOR = [
    '[data-add-to-cart]', // theme buy button + sticky ATC bar
    '#flo-buy-now-button', // Shopflo buy now
    '.shopify-payment-button__button', // dynamic checkout
    '#hozBdAtc',
    '#hozStickyCta', // main-product-zelena
    '#hozv2BdAtc',
    '#hozv2StickyCta', // hoz-product-page-v2
    '[data-atc-patch-btn]' // atc patch (skipped when it points at another product)
  ].join(',');

  function injectStyles() {
    if (document.getElementById('size-required-styles')) return;
    var style = document.createElement('style');
    style.id = 'size-required-styles';
    style.textContent =
      '.' +
      ERROR_CLASS +
      '{display:block;margin:8px 0 0;color:#eb001b;font-size:12px;font-weight:700;' +
      'line-height:1.4;letter-spacing:0.2px;}' +
      '.' +
      ERROR_CLASS +
      '[hidden]{display:none;}' +
      '@keyframes sizeRequiredNudge{0%,100%{transform:translateX(0)}25%{transform:translateX(-4px)}' +
      '75%{transform:translateX(4px)}}' +
      '.size-required-nudge{animation:sizeRequiredNudge .28s ease-in-out 2;}';
    document.head.appendChild(style);
  }

  function isVisible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }

  /* Walk up until an ancestor contains a size group, stopping at the section (or modal)
     boundary. Without the boundary a quick-add button in a "you may also like" grid would
     find the main product's size group and get blocked by it. */
  var BOUNDARY_SELECTOR = '.shopify-section, [data-section-id], [data-quick-view], .quick-view-modal, dialog, body';

  function findGroup(el) {
    var node = el;
    while (node && node.nodeType === 1) {
      if (node.matches(GROUP_SELECTOR)) return node;

      var found = node.querySelector(GROUP_SELECTOR);
      if (found) return found;

      if (node.matches(BOUNDARY_SELECTOR)) return null;
      node = node.parentElement;
    }
    return null;
  }

  function hasSelection(group) {
    return !!group.querySelector(SELECTED_SELECTOR);
  }

  function errorElementFor(group) {
    var next = group.nextElementSibling;
    if (next && next.classList.contains(ERROR_CLASS)) return next;

    var error = document.createElement('div');
    error.className = ERROR_CLASS;
    error.setAttribute('role', 'alert');
    error.hidden = true;
    error.textContent = group.getAttribute('data-size-error-message') || DEFAULT_MESSAGE;
    group.parentNode.insertBefore(error, group.nextSibling);
    return error;
  }

  function showError(group) {
    var error = errorElementFor(group);
    error.hidden = false;

    group.classList.remove('size-required-nudge');
    // Reflow so the animation restarts on repeated taps.
    void group.offsetWidth;
    group.classList.add('size-required-nudge');

    var rect = group.getBoundingClientRect();
    if (rect.top < 0 || rect.bottom > window.innerHeight) {
      group.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function hideError(group) {
    var next = group.nextElementSibling;
    if (next && next.classList.contains(ERROR_CLASS)) next.hidden = true;
    group.classList.remove('size-required-nudge');
  }

  /* Returns true when the action must be stopped. */
  function shouldBlock(el) {
    var group = findGroup(el);
    if (!group || !isVisible(group)) return false;
    if (hasSelection(group)) {
      hideError(group);
      return false;
    }
    showError(group);
    return true;
  }

  function isGuardedButton(el) {
    var btn = el.closest && el.closest(ATC_SELECTOR);
    if (!btn) return null;

    // The ATC patch can advertise a different product — leave that one alone.
    var patch = btn.closest('[data-product-atc-patch]');
    if (patch && patch.getAttribute('data-is-external') === 'true') return null;

    return btn;
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var btn = isGuardedButton(target);
      if (!btn) return;

      if (shouldBlock(btn)) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form')) return;
      if (!form.querySelector('[data-add-to-cart], [name="add"]')) return;

      if (shouldBlock(form)) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  /* Clear the message once a size is picked. Runs after the theme (and the custom
     sections' inline handlers) have applied their selected/active class. */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var group = target.closest(GROUP_SELECTOR);
    if (!group) return;

    setTimeout(function () {
      if (hasSelection(group)) hideError(group);
    }, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectStyles);
  } else {
    injectStyles();
  }
})();
